let messaages_vi = {
	Salutation: {
		required: 'Hãy chọn một lời chào.',
	},
	FirstName: {
		required: 'Vui lòng nhập tên.',
	},
	LastName: {
		required: 'Vui lòng nhập họ.',
	},
	Email: {
		required: 'Vui lòng nhập địa chỉ email.',
		email: 'Vui lòng nhập địa chỉ email hợp lệ.',
	},
	Country: {
		required: 'Vui lòng chọn một quốc gia.',
	},
	Postcode: {
		required: 'Vui lòng chọn mã bưu điện.',
	},
	Password: {
		required: 'Vui lòng nhập mật khẩu.',
	},
	ConfirmPassword: {
		required: 'Vui lòng nhập mật khẩu để xác nhận.',
		equalTo: 'Vui lòng đảm bảo rằng mật khẩu khớp.',
	},
	TermsAndConditions: {
		required: 'Vui lòng đồng ý với các điều khoản và điều kiện.',
	}
};

export function messages_vi() {
	return messaages_vi;
}
